import { Injectable } from '@angular/core';

import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ToasterErrorService } from '../_services/toaster.service';
import { environment } from '../../environments/environment';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class UploadVehiclesService {
  constructor (private http: Http, 
                private toasterErrorService: ToasterErrorService,
                private authService: AuthenticationService) {}

  data: any;

  getVehicles() {
    this.data = this.http.get('/api/upload_vehicles/');
    return this.data;
  }

  uploadQRFile(file: File, customerId: any): Observable<any> {
    return Observable.create(observer => {
        let xhr: XMLHttpRequest = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    observer.next(xhr.response);
                    observer.complete();
                    this.toasterErrorService.toasterSuccess('New QR code urls have been created');
                } else {
                    observer.error(xhr.response);
                    this.toasterErrorService.toasterErr('Error when uploading the new QR codes');
                }
            }
        };

        // xhr.open('PUT', '/api/help/', true);
        xhr.open('PUT', '/api/upload_qr_codes/', true);

        this.authService.fetchJwtTokenFromBearer().then((data) => {
            // Set auth token in header
            if (data) {
                 // Set auth token in header
                if (localStorage.getItem('currentUser') != null) {
                    xhr.setRequestHeader('Authorization', 'JWT ' + data.token);
                }

                let formData = new FormData();
                formData.append('file', file, file.name);
                formData.append('customer_id', customerId)
                xhr.send(formData);
            }
        });
       
    })
  }

  uploadFile(file: File, customerId: any, verifyUpload: any, email: string, uploadChoices: any, scheduled?: boolean): Observable<any> {
    return Observable.create(observer => {

        let xhr:XMLHttpRequest = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    observer.next(JSON.parse(xhr.response));
                    observer.complete();
                } else {
                    observer.error(xhr.response);
                }
            }
        };

        xhr.open('PUT', environment.apiHost + '/api/upload_vehicles/', true);
        /*
        xhr.setRequestHeader("Content-Disposition", "attachment; filename=checkmeout.pdf")
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=utf-8")
        */
        this.authService.fetchJwtTokenFromBearer().then((data) => {
            // Set auth token in header
            if (data) {
                // const jsonData = JSON.parse(data);
                if (localStorage.getItem('currentUser') != null) {
                    xhr.setRequestHeader('Authorization', 'JWT ' + data.token);
                }
                const _sendonWeekend: string = scheduled != null && scheduled === true ? 'true' : 'false';
                let formData = new FormData();
                formData.append('file', file, file.name);
                formData.append('customer_id', customerId);
                formData.append('verifyUpload', verifyUpload);
                formData.append('email', email);
                formData.append('uploadChoices', JSON.stringify(uploadChoices));
                formData.append('run_on_weekend', _sendonWeekend);
                xhr.send(formData);
            }
            

        });
        
    });
  }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/upload-vehicles.service.ts